// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"142fe4eb","453":"7f3bce05","500":"4f57d0b6"}[chunkId] + ".chunk.js";
};